import GuestLayout from "../components/GuestLayout"
import HomeDeals from "../components/HomeDeals"

const Deals = () => {
  return (
    <GuestLayout
      header={true}
      footer={true}
    >
      <HomeDeals searchable />
    </GuestLayout>
  )
}

export default Deals